import { RunningExperiments, useExperiments } from 'state/experiments';

export const useAcceleratorBadgesOnMenuExperiment = (skipExposureLogging = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.AcceleratorBadgesOnMenu, 'treatment', { skipExposureLogging });
};
